import { render, staticRenderFns } from "./MainAppPieGraph.vue?vue&type=template&id=45dd2183&scoped=true&"
import script from "./MainAppPieGraph.vue?vue&type=script&lang=ts&"
export * from "./MainAppPieGraph.vue?vue&type=script&lang=ts&"
import style0 from "./MainAppPieGraph.vue?vue&type=style&index=0&id=45dd2183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd2183",
  null
  
)

export default component.exports